import { useEffect, useState } from 'react';

import { Text } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { useFormContext } from 'react-hook-form';

import { label as lblCommon } from '../../../translation';
interface GivenNamesAndSurNamesProps {
  readonly?: boolean;
  propetyName: string;
  enable: boolean;
  defaultValues?: {
    givenNames?: string;
    surnames?: string;
  };
}

export const GivenNamesAndSurNames = ({
  defaultValues,
  enable,
  readonly,
  propetyName
}: GivenNamesAndSurNamesProps) => {
  const { watch, setValue } = useFormContext();
  const [onLoad, setOnLoad] = useState(false);
  const givenNames = watch('givenNames') || defaultValues?.givenNames;
  const surnames = watch('surnames') || defaultValues?.surnames;

  useEffect(() => {
    if (!readonly) {
      if (onLoad) {
        if (enable) {
          setValue(propetyName, `${givenNames || ''} ${surnames || ''}`.trim());
        } else {
          setValue(propetyName, '');
        }
      } else {
        if (enable) {
          setValue(propetyName, `${givenNames || ''} ${surnames || ''}`.trim());
        }
        setOnLoad(true);
      }
    }
  }, [readonly, enable, givenNames, surnames, setValue]);

  if (enable) {
    return (
      <Row>
        <Col>
          <Text
            defaultValue={defaultValues?.givenNames}
            readonly={readonly}
            name="givenNames"
            label={lblCommon('givenNames')}
          />
        </Col>
        <Col>
          <Text
            defaultValue={defaultValues?.surnames}
            readonly={readonly}
            name="surnames"
            label={lblCommon('surnames')}
          />
        </Col>
      </Row>
    );
  }
  return <></>;
};
